import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DrawerLayout from '../shared/DrawerLayout';
import ReportDrawerBody from './ReportDrawerBody';
import { closeReportDrawerAndSetQueries } from '../../redux/store/ui/common';
import { selectSelectedReport } from '../../redux/store/userData/reports';

const ReportDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const selectedReport = useSelector(selectSelectedReport);
  const visible = selectedReport != null;

  const handleOnClose = () => {
    dispatch(closeReportDrawerAndSetQueries());
  };

  return (
    selectedReport && (
      <DrawerLayout
        visible={visible}
        title={selectedReport?.id!}
        body={<ReportDrawerBody />}
        onReload={undefined}
        onClose={handleOnClose}
      />
    )
  );
};

export default ReportDrawer;
